// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadingBox_wrapper__wOr9x","background":"LoadingBox_background__fGH-d","gradient":"LoadingBox_gradient__T7niC","placeholderShimmer":"LoadingBox_placeholderShimmer__5TogB"};